import React from 'react';
import {Button, Table, message, Pagination, ConfigProvider, Modal, Row, Col, Tag, DatePicker, Input, Image} from 'antd'
import {getOrderList, getOrderShopChange, getOrderCancel, getOrderShopArrived,getOrderAfterSale,AgreeAfterSale,RefuseAfterSale} from "../../constants/api";
import {removeToken} from "../../utils/cookie";
import zhCN from "antd/es/locale/zh_CN";
import './index.less'
import moment from "moment";
import {ReloadOutlined} from "@ant-design/icons";
import Upload from "antd/es/upload";
import {API_IMG_UPLOAD} from "../../constants";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import Divider from "antd/es/divider";
const { CheckableTag } = Tag;
const uploadButton = (
    <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>增加图片</div>
    </div>
);
export default class Order extends React.Component{
    state  = {
        orderInfo:{},
        orderConfirmVisble:false,

        selectedRowKeys: [],
        orderList: [],
        current: 1,
        total: 0,
        pageSize: 10,

        tempOrderId: 0,
        orderCancelModal: false,//订单取消弹窗
        orderReceiveModal: false,//接单弹窗

        selectedTag: '全部',
        selectedStatus: 100,

        orderStart: '',//开始时间
        orderEnd: '',//结束时间
        userName: '',
        userTel: '',

        AgreeModal:false,//同意退款弹窗
        AgreeData:{},//data
        reason:'',//商家回复
        fileList:[],
        previewVisible: false,
        previewImage: '',
        previewTitle: '',
        userImages:[],
        shopImages:[],
        customerImages:[]
    }

    componentDidMount(){
        this.getOrderList(1, this.state.pageSize, 100, '', '', '', '')
    }

    handleCancel = () => this.setState({ previewVisible: false });

    handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        });
    };
    //base64图片文件
    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    handleChange = ({ fileList }) => {
        console.log('改变图片--申请售后图片')
        console.log(fileList)
        this.setState({fileList: fileList})
    };

    getOrderList = (current, pageSize, status, startDate, endDate, userName, userTel) => {
        getOrderList({
            pageIndex: current,
            pageSize: pageSize,
            sortName: "",
            sortType: "",
            dataStatus: status + '',
            startDate: startDate,
            endDate: endDate,
            userName: userName,
            userTel: userTel
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                // console.log(data)
                if (data.code === 0) {
                    if (data.data != null) {
                        this.setState({
                            orderList: data.data.records,
                            total: data.data.total,
                            current: data.data.current
                        })
                    } else {
                        this.setState({
                            orderList: [],
                            total: 0,
                            current: 1
                        })
                    }
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    onChangePage(page, pageSize) {
        this.setState({current: page}, () => {
            this.getOrderList(page, this.state.pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
        })
    }
    onChangePageSize(page, pageSize) {
        this.setState({current: page, pageSize: pageSize}, () => {
            this.getOrderList(page, pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
        })
    }

    onRowClick = (record, index) => {
        let selectKey = [index];
        this.setState({
            selectedRowKeys: selectKey,
            selectedItem: record
        })
    }

    onSelectChange = selectedRowKeys => {
        // console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
        // message.success('您已选择' + selectedRowKeys.length + '单')
    };

    orderCancel = (orderId) => {
        this.setState({tempOrderId: orderId, orderCancelModal: true})
    }
    onHandleOk = () => {
        getOrderCancel({
            id: this.state.tempOrderId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success('取消订单成功')
                    this.setState({orderCancelModal: false}, ()=>{
                        this.getOrderList(1, this.state.pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
                    })
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    onHandleCancel = () => {
        this.setState({orderCancelModal: false})
    }

    orderReceive = (orderId) => {
        // this.setState({tempOrderId: orderId, orderReceiveModal: true})
        getOrderShopChange({
            id: orderId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success('接单成功')
                    this.setState({orderReceiveModal: false}, ()=>{
                        this.getOrderList(1, this.state.pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
                    })
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    onHandleReceiveOk = () => {
        getOrderShopChange({
            id: this.state.tempOrderId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success('接单成功')
                    this.setState({orderReceiveModal: false}, ()=>{
                        this.getOrderList(1, this.state.pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
                    })
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }
    onHandleReceiveCancel = () => {
        this.setState({orderReceiveModal: false})
    }

    orderDelivered = (orderId) => {
        getOrderShopArrived({
            id: orderId
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success('操作成功')
                    this.getOrderList(1, this.state.pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    AgreeModal=(record)=>{
        this.setState({
            AgreeModal:true,
        },()=>{
            getOrderAfterSale({
                id: record.orderId
            }).then((res) => {
                if (res.status === 200) {
                    let data = res.data
                    if (data.code === 0) {
                        if (data.data == null) {
                            this.setState({
                                AgreeData:{}
                            })
                        } else {
                            this.setState({
                                AgreeData:data.data,
                                userImages:data.data.userImages==''||data.data.userImages==null?[]:data.data.userImages.split(","),
                                shopImages:data.data.shopImages==''||data.data.shopImages==null?[]:data.data.shopImages.split(","),
                                customerImages:data.data.customerImages==''||data.data.customerImages==null?[]:data.data.customerImages.split(","),
                            })
                        }
                    } else if (data.code === 50) {
                        message.error(data.msg)
                        removeToken();
                    } else {
                        message.error(data.msg)
                    }
                }
            }).catch(error => {
                message.error(error.toString())
            })
        })
    }

    onAgreeOk=()=>{
        let image = ''
        if (this.state.fileList.length <= 0) {
            image = ''
        } else {
            this.state.fileList.map((item,index)=>{
                let file = item
                if (file.status == 'done') {
                    if (file.response.code == 0) {
                        let response = file.response.data
                        let imageUrl = response.imageSite + response.imagePath
                        if (index == this.state.fileList.length - 1) {
                            image = image + imageUrl
                        } else {
                            image = image + imageUrl + ','
                        }
                    }
                }
            })
        }
        AgreeAfterSale({
            afterSaleId: this.state.AgreeData.afterSaleId,
            images: image,
            reason: this.state.reason
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success('操作成功')
                    this.setState({
                        AgreeModal:false,
                        fileList:[]
                    })
                    this.getOrderList(1, this.state.pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    onAgreeCancel=()=>{
        this.setState({
            AgreeModal:false,
            fileList:[]
        })
    }

    onAgreeCancel2=()=>{
        let image = ''
        if (this.state.fileList.length <= 0) {
            image = ''
        } else {
            this.state.fileList.map((item,index)=>{
                let file = item
                if (file.status == 'done') {
                    if (file.response.code == 0) {
                        let response = file.response.data
                        let imageUrl = response.imageSite + response.imagePath
                        if (index == this.state.fileList.length - 1) {
                            image = image + imageUrl
                        } else {
                            image = image + imageUrl + ','
                        }
                    }
                }
            })
        }
        RefuseAfterSale({
            afterSaleId: this.state.AgreeData.afterSaleId,
            images: image,
            reason: this.state.reason
        }).then((res) => {
            if (res.status === 200) {
                let data = res.data
                if (data.code === 0) {
                    message.success('操作成功')
                    this.setState({
                        AgreeModal:false,
                        fileList:[]
                    })
                    this.getOrderList(1, this.state.pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd)
                } else if (data.code === 50) {
                    message.error(data.msg)
                    removeToken();
                } else {
                    message.error(data.msg)
                }
            }
        }).catch(error => {
            message.error(error.toString())
        })
    }

    handleTagChange(tag, checked) {
        // console.log(tag);
        // console.log(checked);
        this.setState({selectedTag: tag})
        if (tag === '全部') {
            this.setState({selectedStatus: 100}, ()=>{
                this.getOrderList(1, this.state.pageSize, 100, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
            })
        } else if (tag === '待付款') {
            this.setState({selectedStatus: 0}, ()=>{
                this.getOrderList(1, this.state.pageSize, 0, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
            })
        } else if (tag === '已付款') {
            this.setState({selectedStatus: 1}, ()=>{
                this.getOrderList(1, this.state.pageSize, 1, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
            })
        } else if (tag === '已接单') {
            this.setState({selectedStatus: 2}, ()=>{
                this.getOrderList(1, this.state.pageSize, 2, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
            })
        } else if (tag === '已发货') {
            this.setState({selectedStatus: 3}, ()=>{
                this.getOrderList(1, this.state.pageSize, 3, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
            })
        } else if (tag === '已送达') {
            this.setState({selectedStatus: 4}, ()=>{
                this.getOrderList(1, this.state.pageSize, 4, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
            })
        } else if (tag === '已取消') {
            this.setState({selectedStatus: -1}, ()=>{
                this.getOrderList(1, this.state.pageSize, -1, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
            })
        } else if (tag === '售后') {
            this.setState({selectedStatus: 10}, ()=>{
                this.getOrderList(1, this.state.pageSize, 10, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)
            })
        }
    }

    onChangeOrderTimeS(date, dateString) {
        // console.log(dateString)
        this.setState({
            orderStart: dateString
        })
    }
    onChangeOrderTimeE(date, dateString) {
        // console.log(dateString)
        this.setState({
            orderEnd: dateString
        })
    }
    changeInputUserName = (e) => {
        const {value} = e.target;
        this.setState({
            userName: value,
        });
    }
    changeInputUserTel = (e) => {
        const {value} = e.target;
        this.setState({
            userTel: value,
        });
    }

    onCause=(e)=>{
        console.log(e.target.value)
        this.setState({reason:e.target.value})
    }

    render(){
        let {selectedRowKeys} = this.state
        const columns = [
            {
                title: '商品信息',
                dataIndex: 'items',
                width: 280,
                ellipsis: false,
                render: (text, record, index) => (
                    <div className="item-container">
                        <div className="item-container-header">
                            {/*<span style={{fontSize: 30, fontWeight: 'bold', color: '#121212',marginLeft: 7}}>{record.orderNum}、</span>*/}
                            <span style={{fontSize: 14, color: '#121212', marginLeft: 10}}>订单编号：{record.orderNo}</span>
                            {
                                (record.dataStatus == 1 || record.dataStatus == 2) ?
                                    <span style={{fontSize: 16, color: '#FF0000', fontWeight: 'bold', marginLeft: 30}}>预计{record.advanceTime}左右送达！</span>
                                    :
                                    null
                            }

                            {/*<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>*/}
                            {/*    <span style={{fontSize: 14, color: '#121212', marginLeft: 100}}>取单号：</span>*/}
                            {/*    <span style={{fontSize: 26, fontWeight: 'bold', color: '#121212'}}>{record.orderNum}</span>*/}
                            {/*</div>*/}
                        </div>
                        <div className="item-container-img">
                            {
                                (record.items != null && record.items.length > 0) ?
                                    record.items.map((item) => {
                                        return <div key={item.orderItemId} className="item-container-img-bg">
                                            <img style={{width: 100, height: 100}} src={item.productImage}/>
                                            <span style={{fontSize: 14, color: '#121212', width: 100, marginLeft: 5, marginRight: 5}}>{item.productName}</span>
                                            <div className="item-container-img-line"></div>
                                            <span style={{fontSize: 14, color: '#121212', width: 40, marginLeft: 10}}>x{item.buyCount}</span>
                                            <div className="item-container-img-line"></div>
                                            <span style={{fontSize: 14, color: '#121212', width: 60, marginLeft: 5, marginRight: 5}}>￥{item.price}</span>
                                            <div className="item-container-img-line"></div>
                                            <span style={{fontSize: 14, color: '#121212', width: 100, marginLeft: 5, marginRight: 5}}>{item.otherSku}</span>
                                        </div>
                                    })
                                    : null
                            }
                        </div>
                    </div>
                ),
            },
            {
                title:'收货信息',
                dataIndex:'',
                width: 230,
                ellipsis: false,
                render: (text, record) => (
                    <div className="item-container">
                        <div className="item-container-header">
                            <span style={{fontSize: 14, color: '#121212'}}>店名：{record.shopName}</span>
                        </div>
                        <div className="item-container-content">
                            {
                                record.orderNum == 0 ? null :
                                    <span style={{fontSize: 14, color: '#121212', marginLeft: 10}}>取单号：<span style={{fontSize: 26, fontWeight: 'bold', color: '#121212'}}>{record.orderNum}</span></span>
                            }
                            <span style={{fontSize: 14, color: '#121212', marginLeft: 10}}>收货人：{record.userName}</span>
                            <span style={{fontSize: 14, color: '#121212', marginTop: 5, marginLeft: 10}}><span style={{fontSize: 14, backgroundColor: '#ffB800', padding: 2, color: '#ffffff'}}>收</span>{record.userPhone}</span>
                            <span style={{fontSize: 14, color: '#121212', marginTop: 5, marginLeft: 10}}>收货人地址：{record.address}</span>

                        </div>
                    </div>
                ),

            },
            {
                title: '备注信息',
                dataIndex: 'buyerMemo',
                width: 230,
                ellipsis: false,
                render: (text, record) => (
                    <div className="item-container">
                        <div className="item-container-header">
                            <span style={{fontSize: 17, fontWeight: 'bold',padding: 5, color: '#ff5722'}}>￥{record.totalAmount} </span>
                            {
                                record.dataStatus > 0 ?
                                    <span style={{fontSize: 14, color: '#121212', marginLeft: 50}}>付款时间：{record.payTime}</span>
                                    : null
                            }
                        </div>
                        <div className="item-container-content">
                            {
                                record.advanceFlag == 1 ?
                                    <span style={{fontSize: 15, backgroundColor: '#ffB800', padding: 5, color: '#FFFFFF', alignSelf: 'flex-start', marginLeft: 10}}>预约单</span>
                                    : null
                            }
                            {
                                record.advanceFlag == 1 ?
                                    <span style={{fontSize: 14, color: '#121212', marginLeft: 10}}>预约时间：{record.advanceTime}</span>
                                    : null
                            }
                            <span style={{fontSize: 14, color: '#121212', marginLeft: 10}}><span style={{fontSize: 14, color: '#ff6801'}}>备注：</span>{record.remark}</span>
                        </div>
                    </div>
                ),
            },
            {
                title: '操作',
                dataIndex: '',
                width: 145,
                ellipsis: false,
                render: (text, record) => (
                    <div className="item-container">
                        <div className="item-container-header">
                          <span style={{fontSize: 13, fontWeight: 'bold', color: '#1989FA'}}>
                          {
                              record.dataStatus === 0 ?
                                  <span style={{fontSize: 13, fontWeight: 'bold', backgroundColor: '#FF0000', padding: 5, color: '#FFFFFF'}}>待付款</span> :
                                  record.dataStatus === 1 ?
                                      <span style={{fontSize: 13, fontWeight: 'bold', backgroundColor: '#0c9011', padding: 5, color: '#FFFFFF'}}>已付款</span> :
                                      record.dataStatus === 2 ?
                                          <span style={{fontSize: 13, fontWeight: 'bold', backgroundColor: '#0a8277', padding: 5, color: '#FFFFFF'}}>已接单</span> :
                                          record.dataStatus === 3 ?
                                              <span style={{fontSize: 13, fontWeight: 'bold', backgroundColor: '#1E9FFF', padding: 5, color: '#FFFFFF'}}>已发货</span> :
                                              record.dataStatus === 4 ?
                                                  <span style={{fontSize: 13, fontWeight: 'bold', backgroundColor: '#393D49', padding: 5, color: '#FFFFFF'}}>已送达</span> :
                                                  record.dataStatus === 5 ?
                                                      <span style={{fontSize: 13, fontWeight: 'bold', backgroundColor: '#FF5722', padding: 5, color: '#FFFFFF'}}>已收货</span> :
                                                      record.dataStatus === -1 ?
                                                          <span style={{fontSize: 13, fontWeight: 'bold', backgroundColor: '#a5a5a5', padding: 5, color: '#FFFFFF'}}>已取消</span> :
                                                         (record.dataStatus === -2 ||  record.dataStatus === -100) ?
                                                              <span style={{fontSize: 13, fontWeight: 'bold', backgroundColor: '#403735', padding: 5, color: '#FFFFFF'}}>已删除</span> : ''
                          }
                          </span>
                        </div>
                        <div className="item-container-content">
                            {
                                (record.dataStatus >= 1 && record.dataStatus < 4) ?
                                    <Button type='danger' style={{width: 100}} onClick={this.orderCancel.bind(this, record.orderId)}>
                                        拒绝接单
                                    </Button>
                                    : null

                            }
                            {
                                (record.dataStatus == 1 ) ?
                                    <Button style={{width: 100, marginTop: 10, backgroundColor: 'darkgoldenrod', borderColor: 'darkgoldenrod', color: '#fff'}} onClick={this.orderReceive.bind(this, record.orderId)}>
                                        接单
                                    </Button>
                                    : null

                            }
                            {
                                (record.dataStatus > 1 && record.dataStatus < 4) ?
                                    <Button style={{width: 100, marginTop: 10, backgroundColor: '#08900a', borderColor: '#08900a', color: '#fff'}} onClick={this.orderDelivered.bind(this, record.orderId)}>
                                        已送达
                                    </Button>
                                    : null

                            }
                            {
                                record.dataStatus == 4 ?
                                    record.afterSaleStatus!=0&&
                                    (record.afterSaleStatus==2||record.afterSaleStatus==3||record.afterSaleStatus==11||record.afterSaleStatus==12||record.afterSaleStatus==-1||record.afterSaleStatus==-100)?
                                    <Button style={{width: 150, marginTop: 10, backgroundColor: 'red', borderColor: 'red', color: '#fff'}} type="primary" onClick={this.AgreeModal.bind(this, record)}>
                                        查看售后（已处理）
                                    </Button> : null:null
                            }
                            {
                                record.dataStatus == 4 ?
                                    record.afterSaleStatus!=0&&
                                        record.afterSaleStatus==1?
                                        <Button style={{width: 150, marginTop: 10, backgroundColor: 'red', borderColor: 'red', color: '#fff'}} type="primary" onClick={this.AgreeModal.bind(this, record)}>
                                            查看售后（未处理）
                                        </Button> : null:null
                            }
                            {
                                record.dataStatus == 4 &&  record.afterSaleStatus==10 ?
                                    <Button disabled style={{width: 150, color: '#000'}}>
                                        客服介入中
                                    </Button> : null
                            }
                        </div>
                    </div>
                ),
            },
        ]
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const tagsData = ['全部', '已付款', '已接单', '已发货', '已送达', '已取消','售后'];
        return (
            <div>
                <div className="container">
                    <ConfigProvider locale={zhCN}>
                    <Row style={{marginRight: 0, marginBottom: -10, padding: '20px 20px 20px 15px'}} gutter={[8, 8]}>
                        <Col style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} span={10} >
                            <span>状态：</span>{tagsData.map(tag => (
                            <CheckableTag
                                style={{height: '30px', lineHeight: '30px'}}
                                key={tag}
                                checked={this.state.selectedTag === tag}
                                onChange={checked => this.handleTagChange(tag, checked)}
                            >
                                {tag}
                            </CheckableTag>
                        ))}
                        </Col>

                        <Col className="gutter-row" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} span={3}>
                            <DatePicker
                                value={(this.state.orderStart === '') ? null : moment(this.state.orderStart, 'YYYY-MM-DD')}
                                className="header-search"
                                placeholder={'开始时间'}
                                onChange={this.onChangeOrderTimeS.bind(this)}/>
                        </Col>
                        <Col className="gutter-row" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} span={3}>
                            <DatePicker
                                value={(this.state.orderEnd === '') ? null : moment(this.state.orderEnd, 'YYYY-MM-DD')}
                                className="header-search"
                                placeholder={'结束时间'}
                                onChange={this.onChangeOrderTimeE.bind(this)}/>
                        </Col>
                        <Col className="gutter-row" span={3}>
                            <Input placeholder="请输入收货人名称"
                                   onChange={this.changeInputUserName}
                                   allowClear={true}
                                   value={this.state.userName}
                            />
                        </Col>
                        <Col className="gutter-row" span={3}>
                            <Input placeholder="请输入收货人电话"
                                   onChange={this.changeInputUserTel}
                                   allowClear={true}
                                   value={this.state.userTel}
                            />
                        </Col>
                        <Col className="gutter-row" style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} span={2}>
                            <Button type="primary" onClick={this.getOrderList.bind(this, 1, this.state.pageSize, this.state.selectedStatus, this.state.orderStart, this.state.orderEnd, this.state.userName, this.state.userTel)}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                    </ConfigProvider>
                    <Table
                        rowKey="orderId"
                        bordered
                        columns={columns}
                        dataSource={this.state.orderList}
                        pagination={false}
                        // rowSelection={rowSelection}
                        // onRow={(record, index) => {
                        //     return {
                        //         onClick: () => {
                        //             this.onRowClick(record, index);
                        //         }
                        //     };
                        // }}
                    />
                    <ConfigProvider locale={zhCN}>
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center'}}>
                            <span style={{marginRight: 20}}>共<span style={{fontSize: 26, color: '#ff3c00', fontWeight: 'bold'}}>{this.state.total}</span>单</span>
                            <Pagination style={{marginTop: 10}} showQuickJumper={true} showSizeChanger={true}
                                        onShowSizeChange={this.onChangePageSize.bind(this)}
                                        current={this.state.current} pageSize={this.state.pageSize} total={this.state.total}
                                        onChange={this.onChangePage.bind(this)}/>
                        </div>
                    </ConfigProvider>
                </div>

                <Modal
                    visible={this.state.orderCancelModal}
                    onOk={this.onHandleOk.bind(this)}
                    onCancel={this.onHandleCancel.bind(this)}
                    okText="确认"
                    cancelText="取消"
                >
                    确定将订单取消嘛？
                </Modal>

                <Modal
                    visible={this.state.orderReceiveModal}
                    onOk={this.onHandleReceiveOk.bind(this)}
                    onCancel={this.onHandleReceiveCancel.bind(this)}
                    okText="确认"
                    cancelText="取消"
                >
                    确定接单嘛？
                </Modal>

                <Modal
                    title={'售后详情'}
                    width={'30%'}
                    visible={this.state.AgreeModal}
                    // onOk={this.onAgreeOk.bind(this)}
                    onCancel={this.onAgreeCancel.bind(this)}
                    okText="同意"
                    bodyStyle={{maxHeight: "600px", overflow: 'auto',padding:'0 24px 24px 24px'}}
                    cancelText="拒绝"
                    destroyOnClose={true}
                    footer={false}
                >
                    <div>
                        <Divider style={{fontSize: 17, color: 'gray',fontWeight: 'bold'}}>售后信息</Divider>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                            <span style={{fontSize: 16, color: '#121212', width: 120}}>订单号：</span>
                            <span style={{fontSize: 17,fontWeight: 'bold'}}>{this.state.AgreeData.orderNo}</span>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                        <span style={{fontSize: 16, color: '#121212', width: 120}}>状态：</span>
                        {
                            this.state.AgreeData.dataStatus==1?<span style={{color:'#1989FA'}}>第一次售后</span>:
                                this.state.AgreeData.dataStatus==2?<span style={{color:'#1989FA'}}>第一次商家同意</span>:
                                    this.state.AgreeData.dataStatus==3?<span style={{color:'red'}}>第一次商家拒绝</span>:
                                        this.state.AgreeData.dataStatus==5?<span style={{color:'#1989FA'}}>第二次售后</span>:
                                            this.state.AgreeData.dataStatus==6?<span style={{color:'#1989FA'}}>第二次商家同意</span>:
                                                this.state.AgreeData.dataStatus==7?<span style={{color:'red'}}>第二次商家拒绝</span>:
                                                    this.state.AgreeData.dataStatus==10?<span style={{color:'#1989FA'}}>客服介入</span>:
                                                        this.state.AgreeData.dataStatus==11?<span style={{color:'#1989FA'}}>同意</span>:
                                                            this.state.AgreeData.dataStatus==12?<span style={{color:'red'}}>拒绝</span>:
                                                                this.state.AgreeData.dataStatus==-1?<span>取消</span>:
                                                                    this.state.AgreeData.dataStatus==-100?<span>删除</span>:
                                '无'
                        }
                    </div>
                    {
                        this.state.AgreeData.orderAmount==''||this.state.AgreeData.orderAmount==null?null:
                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                <span style={{fontSize: 16, color: '#121212', width: 120}}>订单金额：</span>
                                <span style={{fontSize: 17,color:'red'}}>￥{this.state.AgreeData.orderAmount}</span>
                            </div>
                    }
                    {
                        this.state.AgreeData.applyAmount==''||this.state.AgreeData.applyAmount==null?null:
                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                <span style={{fontSize: 16, color: '#121212', width: 120}}>申请金额：</span>
                                <span style={{fontSize: 17,color:'red'}}>￥{this.state.AgreeData.applyAmount}</span>
                            </div>
                    }
                    <div>
                        {
                            (this.state.AgreeData.applyOperatorName==''||this.state.AgreeData.applyOperatorName==null)
                            &&(this.state.AgreeData.userReason==''||this.state.AgreeData.userReason==null)
                            &&(this.state.userImages.length==0)?null:
                                <Divider style={{fontSize: 17, color: 'gray',fontWeight: 'bold'}}>客户操作</Divider>
                        }
                        {
                            this.state.AgreeData.applyOperatorName==''||this.state.AgreeData.applyOperatorName==null?null:
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                    <span style={{fontSize: 16, color: '#121212', width: 120}}>申请人：</span>
                                    <span style={{fontSize: 17,fontWeight: 'bold'}}>{this.state.AgreeData.applyOperatorName}</span>
                                </div>
                        }
                        {
                            this.state.AgreeData.userReason==''||this.state.AgreeData.userReason==null?null:
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                    <span style={{fontSize: 16, color: '#121212', width: 120}}>用户申请理由：</span>
                                    <span style={{fontSize: 17,color:'#1989FA'}}>{this.state.AgreeData.userReason}</span>
                                </div>
                        }
                        {
                            this.state.userImages.length==0?null:
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                    <span style={{fontSize: 16, color: '#121212', width: 120}}>用户申请图片：</span>
                                    {
                                        this.state.userImages.length==0?null: this.state.userImages.map((item,index)=>{
                                            return <Image key={index} width={70} height={70} src={item} style={{marginRight:10}}/>
                                        })
                                    }
                                </div>
                        }
                    </div>
                    {
                        this.state.AgreeData.dataStatus!=1&&this.state.AgreeData.dataStatus!=5?
                            <div>
                                {
                                    (this.state.AgreeData.shopReason==null||this.state.AgreeData.shopReason=='')
                                    &&(this.state.shopImages.length==0)?null:
                                        <Divider style={{fontSize: 17, color: 'gray',fontWeight: 'bold'}}>商家操作</Divider>
                                }
                                {
                                    this.state.AgreeData.shopReason==null||this.state.AgreeData.shopReason==''?null:
                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                            <span style={{fontSize: 16, color: '#121212', width: 120}}>商家理由：</span>
                                            <span style={{fontSize: 17,color:'#1989FA'}}>{this.state.AgreeData.shopReason}</span>
                                        </div>
                                }
                                {
                                    this.state.shopImages.length==0?null:
                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                            <span style={{fontSize: 16, color: '#121212', width: 120}}>商家回复图片：</span>
                                            {
                                                this.state.shopImages.length==0?null: this.state.shopImages.map((item,index)=>{
                                                    return <Image key={index} width={70} height={70} src={item} style={{marginRight:10}}/>
                                                })
                                            }
                                        </div>
                                }
                            </div>
                            :
                            <div>
                                <Divider style={{fontSize: 17, color: 'gray',fontWeight: 'bold'}}>商家操作</Divider>
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                    <span style={{fontSize: 16, color: '#121212', width: 120}}>商家原因：</span>
                                    <Input.TextArea style={{width: '320px'}} value={this.state.reason}
                                                    onChange={this.onCause} placeholder="原因"/>
                                </div>
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                    <span style={{fontSize: 16, color: '#121212', width: 125, marginRight: 25}}>图片：</span>
                                    <Upload
                                        name="file"
                                        action={API_IMG_UPLOAD}
                                        data={{fileType: 4}}
                                        accept="image/*"
                                        listType="picture-card"
                                        fileList={this.state.fileList}
                                        onPreview={this.handlePreview}
                                        onChange={this.handleChange}
                                    >
                                        {this.state.fileList.length >= 5 ? null : uploadButton}
                                    </Upload>
                                    <Modal
                                        visible={this.state.previewVisible}
                                        title={this.state.previewTitle}
                                        footer={null}
                                        onCancel={this.handleCancel}
                                    >
                                        <img alt="图片" style={{width: '100%',marginRight:0,marginBottom:0}} src={this.state.previewImage}/>
                                    </Modal>
                                </div>
                            </div>
                    }
                    {
                        this.state.AgreeData.dataStatus==1||this.state.AgreeData.dataStatus==5?
                            <div style={{display: 'flex', flexDirection: 'row', marginTop: 10, justifyContent:'flex-end'}}>
                                <Button style={{marginRight:10,backgroundColor:'red',color:'#fff',border:'red'}} onClick={this.onAgreeCancel2.bind(this)}>拒绝</Button>
                                <Button type="primary" onClick={this.onAgreeOk.bind(this)}>同意</Button>
                            </div>:null
                    }
                    {
                        this.state.AgreeData.dataStatus==10? <div style={{display: 'flex', flexDirection: 'row',justifyContent:'center', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                            <span style={{fontSize: 20, color: '#1989FA'}}>用户已申请客服介入,等待客服操作。。。</span>
                        </div>:null
                    }
                    {
                        this.state.AgreeData.dataStatus==11||this.state.AgreeData.dataStatus==12?
                            <div>
                                <Divider style={{fontSize: 17, color: 'gray',fontWeight: 'bold'}}>客服操作</Divider>
                                {
                                    this.state.AgreeData.customerOperatorName==''||this.state.AgreeData.customerOperatorName==null?null:
                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                            <span style={{fontSize: 16, color: '#121212', width: 120}}>客服名称：</span>
                                            <span style={{fontSize: 17,fontWeight: 'bold'}}>{this.state.AgreeData.customerOperatorName}</span>
                                        </div>
                                }
                                {
                                    this.state.AgreeData.customerAmount==null||this.state.AgreeData.customerAmount==''?null:
                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                            <span style={{fontSize: 16, color: '#121212', width: 120}}>最终裁决金额：</span>
                                            <span style={{fontSize: 17,color:'red'}}>{this.state.AgreeData.customerAmount}</span>
                                        </div>
                                }
                                {
                                    this.state.AgreeData.customerReason==''||this.state.AgreeData.customerReason==null?null:
                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                            <span style={{fontSize: 16, color: '#121212', width: 120}}>客服理由：</span>
                                            <span style={{fontSize: 17,color:'#1989FA'}}>{this.state.AgreeData.customerReason}</span>
                                        </div>
                                }
                                {
                                    this.state.customerImages.length==0?null:
                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 10,border:'1px solid #eaeaea'}}>
                                            <span style={{fontSize: 16, color: '#121212', width: 120}}>客服回复图片：</span>
                                            {
                                                this.state.customerImages.length==0?null: this.state.customerImages.map((item,index)=>{
                                                    return <Image key={index} width={70} height={70} src={item} style={{marginRight:10}}/>
                                                })
                                            }
                                        </div>
                                }
                            </div>:null
                    }
                </Modal>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/order/index.js